import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics, BaseModel } from '../../libraries';
import { createUserModel } from './userInfo';
export class ShareController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        this.UserInfo = createUserModel();
    }
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    async getLiveQrCode() {
        try {
            return await AjaxBasics.request(lodash.assign(EnumAPI.live_qrCode, {
                body: {
                    liveId: this.liveId,
                },
            }));
        }
        catch (error) { }
    }
}
